/**
 * The layered wordmark: the canonical pixel-media logo as three always-opaque
 * clipped copies (static trail, solid core, wordmark) over six exhaust
 * particles. Hovering or focusing the brand link hides the static trail and
 * runs the exhaust; everything else is in `styles/coming-soon.css`, keyed on
 * the mark's language class. One box for every layer, so nothing shifts.
 */

import type { ReactNode } from 'react';

import type { Language } from '../../i18n/translations.js';

const SOURCE: Readonly<Record<Language, string>> = {
  en: '/mouja-pixel-media-logo.svg',
  ar: '/mouja-arabic-pixel-media-logo.svg',
};

const PARTICLES = [0, 1, 2, 3, 4, 5] as const;

export function BrandMark({ language }: { readonly language: Language }): ReactNode {
  const source = SOURCE[language];
  return (
    <span className={`cs-mark cs-mark-${language}`} aria-hidden="true">
      <span className="cs-exhaust">
        {PARTICLES.map((index) => (
          <i key={index} />
        ))}
      </span>
      <img className="cs-logo-trail cs-logo-trail-static" src={source} alt="" />
      <img className="cs-logo-core" src={source} alt="" />
      <img className="cs-logo-wordmark" src={source} alt="" />
    </span>
  );
}
